import { RootState } from '../root/root-types';
import {
  BeatPlanTypeEnum,
  FieldOpsCustomerListData,
  NonPeriodicBeatPlanInfoResponse,
} from './field-ops-model';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

export const FIELD_OPS_FEATURE_KEY = 'fieldOpsSlice';

export interface FieldOpsInitialState {
  fieldOpsCustomerList: FieldOpsCustomerListData[];
  nonPeriodicBeatPlanInfo: NonPeriodicBeatPlanInfoResponse | undefined;
  periodicBeatPlanType: BeatPlanTypeEnum | undefined;
  isZoaiCustomerFlow: {
    state: boolean;
    channel: string;
  };
}

export const initialFieldOpsInviteState: FieldOpsInitialState = {
  fieldOpsCustomerList: [],
  nonPeriodicBeatPlanInfo: undefined,
  periodicBeatPlanType: undefined,
  isZoaiCustomerFlow: {
    state: false,
    channel: '',
  },
};

export const fieldOpsSlice = createSlice({
  name: FIELD_OPS_FEATURE_KEY,
  initialState: initialFieldOpsInviteState,
  reducers: {
    updateFieldOpsCustomerList: (
      state,
      action: PayloadAction<FieldOpsCustomerListData[]>
    ) => {
      state.fieldOpsCustomerList = action.payload;
    },
    updateNonPeriodicBeatPlanInfo: (
      state,
      action: PayloadAction<NonPeriodicBeatPlanInfoResponse | undefined>
    ) => {
      state.nonPeriodicBeatPlanInfo = action.payload;
    },
    updatePeriodicBeatPlanInfo: (
      state,
      action: PayloadAction<BeatPlanTypeEnum | undefined>
    ) => {
      state.periodicBeatPlanType = action.payload;
    },
    updateZoaiCustomerFlowState: (
      state,
      action: PayloadAction<{ state: boolean; channel: string }>
    ) => {
      state.isZoaiCustomerFlow = action.payload;
    },
  },
});

export const fieldOpsReducer = fieldOpsSlice.reducer;

export const {
  updateFieldOpsCustomerList,
  updateNonPeriodicBeatPlanInfo,
  updatePeriodicBeatPlanInfo,
  updateZoaiCustomerFlowState,
} = fieldOpsSlice.actions;

export const getFieldOpsState = (rootState: RootState): FieldOpsInitialState =>
  rootState[FIELD_OPS_FEATURE_KEY];

export const getFieldOpsCustomeList = createSelector(
  getFieldOpsState,
  (state) => state.fieldOpsCustomerList
);

export const getNonPeriodicBeatPlanInfo = createSelector(
  getFieldOpsState,
  (state) => state.nonPeriodicBeatPlanInfo
);

export const getPeriodicBeatPlanInfo = createSelector(
  getFieldOpsState,
  (state) => state.periodicBeatPlanType
);

export const getIsZoaiCustomerFlowState = createSelector(
  getFieldOpsState,
  (state) => state.isZoaiCustomerFlow
);
